import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/* -----------------------------------------
   Gentle SVG card flip
----------------------------------------- */
function animateIcon(icon) {
  gsap.timeline({
    onComplete: () => {
      gsap.delayedCall(
        gsap.utils.random(6, 12),
        () => animateIcon(icon)
      );
    }
  })
  .to(icon, {
    rotationY: 180,
    duration: 1.4,
    ease: "power2.inOut"
  })
  .to(icon, {
    rotationY: 0,
    duration: 1.4,
    ease: "power2.inOut"
  });
}

/* -----------------------------------------
   Reveal + loop
----------------------------------------- */
gsap.utils.toArray(".icon-servizio").forEach((icon) => {

  const paths = icon.querySelectorAll("path");

  gsap.from(paths, {
    opacity: 0,
    y: 12,
    rotationZ: gsap.utils.random(-6, 6),
    stagger: 0.06,
    duration: 1,
    ease: "power3.out",
    clearProps: "transform",
    scrollTrigger: {
      trigger: icon,
      start: "top 85%",
      toggleActions: "play none play none",
      onEnter: () => {
        gsap.delayedCall(
          gsap.utils.random(2, 5),
          () => animateIcon(icon)
        );
      }
    }
  });

});